import type { LocationsList } from 'root/types/locations';
import type { PopulatedMenu } from 'root/apiTypes';

export const getLocations = (menus: PopulatedMenu[]) => {
  return menus.reduce((acc, menu) => {
    const locationId = menu.businessLocationId;
    const locationName = menu.businessLocationDetails?.name;
    if (locationId && locationName) {
      acc[locationId] = locationName;
    }
    return acc;
  }, {} as LocationsList);
};
